export function gtmSendEvent(eventName, payload = {}) {
  if (gtag) gtag("event", eventName, payload);
}

export const gtmClickEventDirective = {
  mounted(el, binding) {
    el.addEventListener("click", () => {
      const { value } = binding;
      gtmSendEvent(value);
    });
  },
};
